export const auth = {
  authHomeTitle: 'Vamos começar',
  authHomeButtonBranded: 'Continuar com E-mail',
  authHomeButtonApple: 'Continuar com Apple',
  authHomeButtonGoogle: 'Continuar com Google',
  authHomeButtonFacebook: 'Continuar com Facebook',
  authHomeButtonLinkedin: 'Continuar com LinkedIn',
  authStartTitle: 'Entrar ou Registrar',
  authStartInputTitle: 'E-mail',
  authStartInputTitleError: 'Insira um endereço de e-mail válido!',
  authStartInputPasswordError: 'Insira uma senha válida!',
  authWhoops: 'Ops!',
  authStartConfirmButton: 'Continuar',
  authRegisteredTitle: 'Bem-vindo de volta!',
  authStartPlaceholderTitle: 'E-mail',
  authRegisteredInputTitle: 'Senha',
  authRegisteredForgotPassword: 'Esqueceu a senha',
  authAlertIncorrectPassword: 'Seu E-mail ou Senha está incorreto',
  authAlertRequiredPassword: 'Insira uma senha válida',
  authFinishSignUpTitle: 'Concluir Cadastro',
  authFinishSignUpEmailInputTitle: 'E-mail',
  authFinishSignUpFirstNameInputTitle: 'Nome',
  authFinishSignUpLastNameInputTitle: 'Sobrenome',
  authFinishSignUpPasswordInputTitle: 'Senha',
  authFinishSignUpTipContent:
    '<ul class="text-14 pl-4 text-black"><li class="-ml-4 list-none">Recomendamos usar:</li><li class="list-disc">Pelo menos 8 caracteres</li><li class="list-disc">Incluir 1 número</li><li class="list-disc">Incluir 1 símbolo especial</li></ul>',
  authFinishSignUpPrivacyAndTerms: {
    text1: 'Ao clicar em Registrar, você concorda com nossa',
    privacyPolicy: 'Política de Privacidade',
    text2: 'e',
    termsOfUse: 'Termos de Uso'
  },
  authFinishSignUpConfirmButton: 'Registrar',
  authFinishSignUpErrorFirstName: 'O Nome não pode estar vazio!',
  authFinishSignUpErrorLastName: 'O Sobrenome não pode estar vazio!',
  authFinishSignUpErrorPassword: 'A Senha é muito curta!',
  authEmailConfirmationTitle: 'Verifique sua caixa de entrada',
  authEmailConfirmationContent:
    'Enviamos um e-mail de confirmação para verificar seu endereço de e-mail. Por favor, verifique também sua caixa de spam se não encontrar na sua caixa de entrada.',
  authEmailConfirmationConfirmButton: 'Voltar para o Login',
  authAlertEmailConfirmation: 'Por favor, verifique sua caixa de entrada para confirmar seu e-mail!',
  authResetPasswordTitle: 'Verifique sua caixa de entrada',
  authResetPasswordDescription:
    'Enviamos um link de redefinição de senha para o seu e-mail. Por favor, verifique também sua caixa de spam se não encontrar na sua caixa de entrada.',
  authResetPasswordButton: 'Voltar para o login',
  authNewPasswordTitle: 'Digite a nova senha',
  authNewPasswordInputTitle: 'Nova senha',
  authNewPasswordButton: 'Redefinir senha',
  authNewPasswordAlertValidation: 'Sua senha não é forte o suficiente',
  authPasswordChangeSuccessTitle: 'Senha alterada!',
  authPasswordChangeSuccessContent: 'Sua senha foi alterada com sucesso!',
  authPasswordChangeSuccessButton: 'Voltar para o login',
  authPasswordChangeErrorTitle: 'Erro!',
  authPasswordChangeErrorContent: 'Algo deu errado ao tentar redefinir sua senha! Tente novamente mais tarde.',
  authPasswordChangeErrorButton: 'Voltar para o Login',
  authInvitationTitle: 'Escolha uma senha',
  authInvitationInputTitle: 'Senha',
  authInvitationButton: 'Configurar senha',
  authEmailAddressConfirmed: 'Endereço de e-mail confirmado!'
}
